import * as ListingDocument3 from "./ListingDocument3";
import * as ListingDocument7 from "./ListingDocument7";
import * as S3BucketUrl from "./S3BucketUrl";

export const fromListingDocument2AndAccountName = (document: ListingDocument3.T, accountName: string): string =>
    `${S3BucketUrl.fromAccountAndBucketNames(accountName, S3BucketUrl.bucketNames.LISTINGS_DOCUMENTS_BUCKET)}/${document.id}/${document.id}.${document.file_extension}`;

export const fromListingDocument7AndAccountName = (document: ListingDocument7.T, accountName: string): string =>
    `${S3BucketUrl.fromAccountAndBucketNames(accountName, S3BucketUrl.bucketNames.LISTINGS_DOCUMENTS_BUCKET)}/${document.id}/${document.id}.${document.file_extension}`;
